import * as types from "./types";
import _ from "lodash";
import { normalizeFranchiseName } from "@/helpers/franchise";

const createKpiRow = ({
  id,
  digitalFranchiseId,
  leaderFranchiseName = "",
  name = null,
} = {}) => ({
  id: id ? Number(id) : null,
  leader_franchise_name: normalizeFranchiseName(leaderFranchiseName || ""),
  digital_franchise_id: digitalFranchiseId ? Number(digitalFranchiseId) : null,
  name,
  hot_leads_quantity: 0,
  scheduled_interview_quantity: 0,
  pre_interviews_quantity: 0,
  interviews_quantity: 0,
  customers_quantity: 0,
  interview_contract_quantity: 0,
  done_interview_quantity: 0,
  client_leads_quantity: 0,
  consultant_leads_quantity: 0,
  scheduled_x_moment_quantity: 0,
  done_x_moment_quantity: 0,
  x_moment_positive_feedbacks_quantity: 0,
  scheduled_partnership_quantity: 0,
  done_partnership_quantity: 0,
  partnership_positive_feedbacks_quantity: 0,
  interview_contract_amount: 0,
  subscription_contract_amount: 0,
  renewal_contract_amount: 0,
  other_financial_solutions_contract_amount: 0,
  total_contract_amount: 0,
  signature_contract_quantity: 0,
  support_contract_quantity: 0,
  scheduled_negotiation_quantity: 0,
  negotiation_positive_feedbacks_quantity: 0,
  renewal_contract_quantity: 0,
  negotiation_interview_contract_quantity: 0,
});

export default {
  [types.MUTATE_CONSULTANTS]: (state, payload) => {
    state.consultants = payload;
  },
  [types.MUTATE_KPI_LIST]: (state, payload) => {
    state.kpiList = _.map(payload, (item) => {
      const base = createKpiRow({
        id: item.id ?? item.consultant_id,
        digitalFranchiseId: item.digital_franchise_id,
        leaderFranchiseName: item.leader_franchise_name,
        name: item.name ?? item.consultant_name,
      })
      return Object.assign(base, item, {
        id: base.id,
        digital_franchise_id: base.digital_franchise_id,
        leader_franchise_name: base.leader_franchise_name,
        name: base.name,
      })
    })
  },
  [types.MUTATE_KPI_LIST_CONTENT]: (state, payload) => {
    const skipKeys = new Set(['consultant_id', 'digital_franchise_id']);
    _.forEach(payload, (e) => {
      const consultantId = Number(e.consultant_id);
      const digitalFranchiseId = Number(e.digital_franchise_id);
      let kpiRow = _.find(state.kpiList, {
        id: consultantId,
        digital_franchise_id: digitalFranchiseId,
      });

      if (kpiRow) {
        _.assign(kpiRow, e);
      } else {
        const primaryRow = _.find(state.kpiList, { id: consultantId });
        if (primaryRow) {
          // Consultant appears under a different digital_franchise_id in performance
          // data (e.g. contract_networks has extra franchise entries). Merge numeric
          // values into the primary row instead of creating a duplicate entry.
          _.forEach(e, (value, key) => {
            if (skipKeys.has(key)) return;
            if (_.isNumber(value) && _.isNumber(primaryRow[key])) {
              primaryRow[key] += value;
            }
          });
          kpiRow = primaryRow;
        } else {
          kpiRow = createKpiRow({
            id: consultantId,
            digitalFranchiseId,
            leaderFranchiseName: e.leader_franchise_name || '',
            name: e.consultant_name || null,
          });
          state.kpiList.push(kpiRow);
          _.assign(kpiRow, e);
        }
      }

      if (kpiRow.leader_franchise_name) {
        kpiRow.leader_franchise_name = normalizeFranchiseName(kpiRow.leader_franchise_name);
      }
      if (!kpiRow.name && e.consultant_name) {
        kpiRow.name = e.consultant_name;
      }
    });
  },
  [types.MUTATE_NEW_CAMPAIGN_KPI_SIDEBAR]: (state, payload) => {
    state.newCampaignKpiSidebar = { ...state.newCampaignKpiSidebar, ...payload }
  },
  [types.MUTATE_NEW_CAMPAIGN_KPI_ARRAY]: (state, payload) => {
    state.campaigns = payload;
  },[types.MUTATE_ADD_CAMPAIGN_KPI_ARRAY]: (state, payload) => {
    state.campaigns.push(payload);
  },
};
